// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".set-layout-item{width:100px;height:100px;display:inline-block;margin-right:10px}", ""]);
// Exports
module.exports = exports;
